import { Col, Container, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import createPaginationControl from "../Common/createPaginationControl";
import IleggelseFilterContainer from "./InnsynIleggelseFilterContainer";
import IleggelserList from "./InnsynIleggelserList";
import NavigationBarContainer from "./NavigationBarContainer";

import { getIleggelseList } from "../../selectors/ileggelserSelector";

import { getIleggelser } from "../../actions/ileggelserActions";

import "./innsyn.css";

const PaginationControl = createPaginationControl(
  "ileggelser",
  {
    apiCallAction: getIleggelser,
    queriesForApiReducerName: "forms.InnsynIleggelserFilterFormState",
  },
  getIleggelseList,
);

export default function InnsynIleggelsePage() {
  const ileggelser = useSelector((state) => state.ileggelser);

  return (
    <Container fluid>
      <Row>
        <Col>
          <NavigationBarContainer page="ileggelser" />
          <div className="SearchFormDiv">
            <IleggelseFilterContainer />
          </div>
          <div
            className="pull-right ileggelse-list-page-total-ileggelser"
            style={{ height: 50, marginTop: 20, paddingRight: 50 }}
          >
            {ileggelser.total} ileggelser
          </div>
          <div>
            <div className="tableContainer">
              <IleggelserList body={ileggelser} />
              <PaginationControl storeKey="ileggelser" />
              <div style={{ height: 50 }} />
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
}
